'use strict'

const maybe = require('folktale/maybe')
const isPlainObject_ = require('lodash/isPlainObject')
const flatMap_ = require('lodash/flatMap')
const set_ = require('lodash/set')
const cloneDeep_ = require('lodash/cloneDeep')

const {
  shouldResolve: shouldCurrentUserResolve
} = require('dbsm-common/src/filter-resolvers/currentUserFilterResolver')
const {
  shouldResolve: shouldDataBindingResolve
} = require('dbsm-common/src/filter-resolvers/dataBindingFilterResolver')

const shouldResolve = filterExpression =>
  shouldCurrentUserResolve(filterExpression) ||
  shouldDataBindingResolve(filterExpression)

const getFilterExpressionsToResolve = (filterPart, path = []) => {
  if (shouldResolve(filterPart)) {
    return [
      {
        path: path.slice(),
        filterExpression: filterPart
      }
    ]
  }

  if (Array.isArray(filterPart) || isPlainObject_(filterPart)) {
    return flatMap_(filterPart, (value, key) =>
      getFilterExpressionsToResolve(value, path.concat(key))
    )
  }

  return []
}

const resolveFilter = filterResolvers => filter => {
  const resolveValue = filterExpression => {
    if (shouldCurrentUserResolve(filterExpression)) {
      return filterResolvers.currentUser()
    }

    if (shouldDataBindingResolve(filterExpression)) {
      return filterResolvers.dataBinding(filterExpression)
    }
  }

  const filterExpressionsToResolve = getFilterExpressionsToResolve(filter)

  const resolvedExpressions = filterExpressionsToResolve.reduce(
    (acc, { filterExpression, path }) =>
      acc.concat({
        path,
        resolvedValue: resolveValue(filterExpression)
      }),
    []
  )

  const applyResolvedValue = (filter, path, resolvedValue) =>
    resolvedValue.map(resolvedValue => set_(filter, path, resolvedValue))

  return resolvedExpressions.reduce(
    (maybeResolvedFilter, { path, resolvedValue }) =>
      maybeResolvedFilter.chain(filter =>
        applyResolvedValue(filter, path, resolvedValue)
      ),
    maybe.Just(cloneDeep_(filter))
  )
}

const extractDependencies = filter => {
  const filterExpressionsToResolve = getFilterExpressionsToResolve(filter)
  return filterExpressionsToResolve.map(
    ({ filterExpression }) => filterExpression.filterId
  )
}

const currentUserFilterResolver = wixCodeSdk => () =>
  maybe
    .fromNullable(wixCodeSdk.user.currentUser)
    .chain(currentUser => maybe.fromNullable(currentUser.id))

const dataBindingFilterResolver = dependenciesMap => ({ filterId }) =>
  maybe
    .fromNullable(dependenciesMap[filterId])
    .chain(({ controllerApi, fieldName }) =>
      maybe
        .fromNullable(controllerApi.getCurrentItem())
        .map(item => item[fieldName])
    )

module.exports.createFilterResolver = resolveFilter
module.exports.extractDependencies = extractDependencies
module.exports.createValueResolvers = (dependenciesMap, wixSdk) => ({
  dataBinding: dataBindingFilterResolver(dependenciesMap),
  currentUser: currentUserFilterResolver(wixSdk)
})



// WEBPACK FOOTER //
// ./helpers/filters.js